import { useTranslation } from 'react-i18next';

import { cn } from '@/shared/lib/cn';

const LANGUAGES = [
  { code: 'ar' as const, labelKey: 'language.ar' },
  { code: 'en' as const, labelKey: 'language.en' },
];

export function LanguageSwitcher({ className }: { className?: string }) {
  const { t, i18n } = useTranslation();
  const current = i18n.resolvedLanguage?.startsWith('en') ? 'en' : 'ar';

  return (
    <div
      className={cn('inline-flex rounded-lg border border-border bg-muted/30 p-0.5', className)}
      role="group"
      aria-label={t('language.label')}
    >
      {LANGUAGES.map(({ code, labelKey }) => (
        <button
          key={code}
          type="button"
          className={cn(
            'rounded-md px-1.5 py-0.5 text-[11px] font-medium transition-colors sm:px-2.5 sm:py-1 sm:text-xs',
            current === code
              ? 'bg-card text-foreground shadow-sm'
              : 'text-muted-foreground hover:text-foreground',
          )}
          aria-pressed={current === code}
          onClick={() => void i18n.changeLanguage(code)}
        >
          {t(labelKey)}
        </button>
      ))}
    </div>
  );
}
